module.exports = __webpack_public_path__ + "U.svg?6249a48f3283f4053709fe5276a3c99a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/U.svg
// module id = 70
// module chunks = 0